import type { EChartsOption } from 'echarts';
import type { CumulativeAnalysisChart } from '../../services/graphApi';

const maleColor = '#4f8fe8';
const femaleColor = '#ee7098';
const unknownColor = '#16a34a';

function getMaxParticipantCount(chart: CumulativeAnalysisChart) {
  return chart.splits.reduce(
    (max, split) => Math.max(
      max,
      split.totalParticipantCount
    ),
    0
  );
}

export function createCumulativeAnalysisOption(
  chart: CumulativeAnalysisChart,
  collectGender = true
): EChartsOption {
  const labels = chart.splits.map((split) => split.splitName);
  const maxParticipantCount = getMaxParticipantCount(chart);

  return {
    backgroundColor: '#ffffff',
    animation: false,
    color: [maleColor, femaleColor, unknownColor],
    grid: {
      left: 52,
      right: 28,
      top: 72,
      bottom: 44,
      containLabel: true,
    },
    legend: {
      top: 16,
      right: 24,
      itemWidth: 10,
      itemHeight: 10,
      textStyle: {
        color: '#64748b',
        fontSize: 11,
        fontWeight: 700,
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    xAxis: {
      type: 'category',
      name: 'splits',
      nameGap: 4,
      nameLocation: 'end',
      data: labels,
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
      },
      axisLine: {
        lineStyle: {
          color: '#e5e7eb',
        },
      },
    },
    yAxis: {
      type: 'value',
      name: 'participants',
      min: 0,
      max: Math.max(Math.ceil(maxParticipantCount / 100) * 100, 100),
      minInterval: 1,
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
      },
      splitLine: {
        lineStyle: {
          color: '#edf2f7',
        },
      },
    },
    series: collectGender ? [
      {
        name: 'Female',
        type: 'bar',
        stack: 'gender',
        barWidth: '46%',
        label: {
          show: true,
          position: 'inside',
          color: '#ffffff',
          fontSize: 10,
          fontWeight: 800,
        },
        itemStyle: {
          color: femaleColor,
        },
        data: chart.splits.map((split) => split.femaleParticipantCount),
      },
      {
        name: 'Male',
        type: 'bar',
        stack: 'gender',
        barWidth: '46%',
        label: {
          show: true,
          position: 'inside',
          color: '#ffffff',
          fontSize: 10,
          fontWeight: 800,
        },
        itemStyle: {
          color: maleColor,
        },
        data: chart.splits.map((split) => split.maleParticipantCount),
      },
      {
        name: '성별 미입력',
        type: 'bar',
        stack: 'gender',
        barWidth: '46%',
        label: {
          show: true,
          position: 'inside',
          color: '#ffffff',
          fontSize: 10,
          fontWeight: 800,
        },
        itemStyle: { color: unknownColor },
        data: chart.splits.map((split) => split.unknownGenderParticipantCount),
      },
    ] : [
      {
        name: '전체',
        type: 'bar',
        barWidth: '46%',
        label: {
          show: true,
          position: 'inside',
          color: '#ffffff',
          fontSize: 10,
          fontWeight: 800,
        },
        itemStyle: { color: maleColor },
        data: chart.splits.map((split) => split.totalParticipantCount),
      },
    ],
  };
}
